<template>
	<app-page>
		<app-heading :title="isNew ? 'New Namespace' : namespace.name" />
		<app-form @submit="onSubmit">
			<app-section style="width: 500px;" class="mt-4">
				<app-section-actions>
					<app-button type="submit" small color="success" v-if="isNew">Create</app-button>
					<app-button type="submit" small color="primary" v-else>Save</app-button>
					<app-button type="cancel" small :to="{ name: prevRoute }">Cancel</app-button>
				</app-section-actions>
				<input-text
					label="Name"
					v-model="namespace.name"
					required
					:errors="errors.name"
				/>
				<input-text
					label="Slug"
					v-model="namespace.slug"
					required
					:errors="errors.slug"
				/>
			</app-section>
		</app-form>
	</app-page>
</template>

<script>
import websiteItemParentMixin from '@/mixins/websiteitemparent'

export default {
	mixins: [websiteItemParentMixin],
	data() {
		return {
			namespace: {
				name: '',
				slug: '',
			},
			errors: {},
		}
	},
	computed: {
		id() {
			return this.$route.params.namespace
		},
		isNew() {
			return this.id === 'new'
		},
		prevRoute() {
			return this.isTemplate ? 'website-template-namespaces' : 'website-namespaces'
		},
	},
	async created() {
		this.$store.dispatch('app/startLoading')
		try {
			if (this.id !== 'new') {
				this.namespace = await this.$ravello.request()
					.v(2)
					.to(this.parentEndpoint)
					.to(this.parentId)
					.to('namespaces')
					.to(this.id)
					.get()
			}
		} catch (err) {
			this.$notifications.pushAlert('error', err.data.message)
		}
		this.$store.dispatch('app/stopLoading')
	},
	methods: {
		async onSubmit() {
			this.$store.dispatch('app/startLoading')
			try {
				if (this.isNew) {
					await this.$ravello.request()
						.v(2)
						.to(this.parentEndpoint)
						.to(this.parentId)
						.to('namespaces')
						.create({
							name: this.namespace.name,
							slug: this.namespace.slug,
						})
				} else {
					await this.$ravello.request()
						.v(2)
						.to(this.parentEndpoint)
						.to(this.parentId)
						.to('namespaces')
						.to(this.id)
						.update({
							name: this.namespace.name,
							slug: this.namespace.slug,
						})
				}
				this.$store.dispatch('app/stopLoading')
				this.$notifications.pushAlert('success', `Namespace successfully ${this.isNew ? 'added' : 'updated'}`)
				this.$router.push({ name: this.prevRoute })
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
				if (err.status === 400) {
					this.errors = err.data.details || {}
				}
				this.$store.dispatch('app/stopLoading')
			}
		},
	},
}
</script>
